const API_BASE = '/api/loyalty';
const CUSTOMER_TOKEN_KEY = 'loyaltyCustomerToken';
const ADMIN_TOKEN_KEY = 'loyaltyAdminToken';

async function request(path, options = {}, token) {
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...options.headers },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) { const error = new Error(data.error || '系統暫時無法使用'); error.status = response.status; throw error; }
  return data;
}

const cardApi = {
  getCustomerToken: () => localStorage.getItem(CUSTOMER_TOKEN_KEY),
  logoutCustomer: () => localStorage.removeItem(CUSTOMER_TOKEN_KEY),
  getMerchants: () => request('/merchants'),
  async customerLogin(payload) { const result = await request('/auth/login', { method: 'POST', body: JSON.stringify(payload) }); localStorage.setItem(CUSTOMER_TOKEN_KEY, result.token); return result.card; },
  getCard() { return request('/card', {}, this.getCustomerToken()); },
  async selectMerchant(merchantId) { const result = await request('/card/merchant', { method: 'POST', body: JSON.stringify({ merchantId }) }, this.getCustomerToken()); localStorage.setItem(CUSTOMER_TOKEN_KEY, result.token); return result.card; },
  claim() { return request('/card/claims', { method: 'POST' }, this.getCustomerToken()); },
  getAdminToken: () => localStorage.getItem(ADMIN_TOKEN_KEY),
  logoutAdmin: () => localStorage.removeItem(ADMIN_TOKEN_KEY),
  async adminLogin(account, password) { const result = await request('/admin/login', { method: 'POST', body: JSON.stringify({ account, password }) }); localStorage.setItem(ADMIN_TOKEN_KEY, result.token); return result; },
  adminDashboard() { return request('/admin/dashboard', {}, this.getAdminToken()); },
  adminClaims() { return request('/admin/claims', {}, this.getAdminToken()); },
  approveClaim(id) { return request(`/admin/claims/${id}/approve`, { method: 'POST' }, this.getAdminToken()); },
  deleteClaim(id) { return request(`/admin/claims/${id}`, { method: 'DELETE' }, this.getAdminToken()); },
  adminMerchants() { return request('/admin/merchants', {}, this.getAdminToken()); },
  updateMerchant(id, payload) { return request(`/admin/merchants/${id}`, { method: 'PUT', body: JSON.stringify(payload) }, this.getAdminToken()); },
  rewardRules(merchantId) { return request(`/admin/reward-rules?merchantId=${merchantId}`, {}, this.getAdminToken()); },
  updateRewardRule(id, payload) { return request(`/admin/reward-rules/${id}`, { method: 'PUT', body: JSON.stringify(payload) }, this.getAdminToken()); },
  customers() { return request('/admin/customers', {}, this.getAdminToken()); },
  customerDetail(id) { return request(`/admin/customers/${id}`, {}, this.getAdminToken()); },
  resetMembership(id) { return request(`/admin/memberships/${id}`, { method: 'DELETE' }, this.getAdminToken()); },
  cancelApprovedClaim(id) { return request(`/admin/claims/${id}/cancel`, { method: 'POST' }, this.getAdminToken()); },
  rewards(params = {}) { return request(`/admin/rewards?${new URLSearchParams(params)}`, {}, this.getAdminToken()); },
  issueReward(id) { return request(`/admin/rewards/${id}/issue`, { method: 'POST' }, this.getAdminToken()); },
};

export default cardApi;
